export default class CreateOrderPreset {
  constructor() {
    this.name = '';
    this.area = '';
  }
}